import { Base64 } from 'js-base64';

import { DEFAULT_PROFILE_PICTURE } from '@/consts';

import { SET_TOKEN, SET_REFRESH_TOKEN, SET_PROFILE, SET_BRANCH, SET_SIP_INFO, CLEAR } from './types';

export const INIT_STATE = {
  token: '',
  refreshToken: '',
  profile: {
    firstName: '',
    lastName: '',
    username: '',
    profilePicture: DEFAULT_PROFILE_PICTURE
  },
  branch: '',
  sip: {
    username: '',
    password: ''
  }
};

const mutations = {
  [SET_TOKEN](state, token = '') {
    state.token = token;
  },

  [SET_REFRESH_TOKEN](state, refreshToken = '') {
    state.refreshToken = refreshToken;

    // fusion with v1
    window.$cookies.set('refresh_token', refreshToken);
  },

  [SET_PROFILE](state, { firstName = '', lastName = '', username = '', profilePicture = DEFAULT_PROFILE_PICTURE }) {
    state.profile = { firstName, lastName, username, profilePicture: profilePicture || DEFAULT_PROFILE_PICTURE };

    // fusion with v1
    localStorage.setItem('profile', Base64.encode(JSON.stringify({ name: `${firstName} ${lastName}` })));
  },

  [SET_BRANCH](state, branch = '') {
    state.branch = branch;

    // fusion with v1
    const { name, id } = this.state.app.branches.find((item) => (item.name === branch));
    localStorage.setItem('current_branch', JSON.stringify({ name, id }));
  },

  [SET_SIP_INFO](state, { username = '', password = '' }) {
    state.sip = { username, password };
  },

  [CLEAR](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });

    // fusion with v1
    window.$cookies.remove('access_token');
    window.$cookies.remove('refresh_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('current_branch');
  }
};

export default mutations;
